import { useToastStore } from "@/Components/Toast/store";

export function showErrorAlert(error: unknown): void {
  const text =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "Ocorreu um erro inesperado.";

  useToastStore.getState().push("error", text);
}
